module.exports = __webpack_public_path__ + "img/raccoon.d286bc88.png";